export enum Role {
  SUPER_ADMIN = 1, /* 超级管理员 */
  DIGITAL_ADMIN = 2, /* Digital管理员 */
  CHANNEL_ADMIN = 3, /* 专栏管理员 */
  // APP_ADMIN = 4, /* 应用管理员 */
}
